import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

export function AskAboutThis({ type, refId, title }) {
  const navigate = useNavigate();
  return (
    <button
      data-testid={`ask-about-this-${type}-${refId}`}
      onClick={() => navigate(`/guide?type=${type}&ref=${refId}&q=${encodeURIComponent(`Tell me more about "${title}"`)}`)}
      className="inline-flex items-center gap-2 text-xs uppercase tracking-wide border border-white/20 px-3 py-2 hover:border-brandAccent hover:text-brandAccent transition-colors duration-200"
    >
      <Sparkles className="w-3.5 h-3.5" /> Ask Mr.E about this
    </button>
  );
}
